import { CheckCircle } from '@mui/icons-material'
import { Box, Button, Dialog, DialogContent, Typography } from '@mui/material'

interface SuccessModalProps {
  open: boolean
  onClose: () => void
}

export default function SuccessModal({ open, onClose }: SuccessModalProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '24px',
          maxWidth: '420px',
          width: '100%',
          margin: '16px',
          backgroundColor: '#ffffff',
          boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
          overflow: 'hidden'
        }
      }}
    >
      <DialogContent sx={{ textAlign: 'center', p: 0 }}>
        {/* Success Icon Container */}
        <Box
          sx={{
            padding: '32px 24px 24px',
            position: 'relative'
          }}
        >
          <Box
            sx={{
              width: '80px',
              height: '80px',
              borderRadius: '50%',
              backgroundColor: '#10b981',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 0px',
              boxShadow: '0 8px 16px rgba(16, 185, 129, 0.3)'
            }}
          >
            <CheckCircle
              sx={{
                fontSize: '48px',
                color: 'white'
              }}
            />
          </Box>
        </Box>

        {/* Content Container */}
        <Box sx={{ padding: '24px 32px 32px' }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: '700',
              marginBottom: '12px',
              color: '#1f2937',
              fontSize: '28px',
              lineHeight: 1.2
            }}
          >
            You&apos;re all set!
          </Typography>
          <Typography
            variant="body1"
            sx={{
              marginBottom: '32px',
              color: '#6b7280',
              fontSize: '16px',
              lineHeight: 1.5
            }}
          >
            Your purchase was successful and your account has been upgraded.
          </Typography>
          <Button
            variant="contained"
            onClick={onClose}
            sx={{
              backgroundColor: '#3b82f6',
              color: 'white',
              borderRadius: '12px',
              padding: '14px 40px',
              fontSize: '16px',
              fontWeight: '600',
              textTransform: 'none',
              minWidth: '120px',
              boxShadow: '0 4px 12px rgba(59, 130, 246, 0.4)',
              '&:hover': {
                backgroundColor: '#2563eb',
                boxShadow: '0 6px 16px rgba(59, 130, 246, 0.5)',
                transform: 'translateY(-1px)'
              },
              transition: 'all 0.2s ease-in-out'
            }}
          >
            Continue
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  )
}
